export class MoniesHeldYesOrNoValueConverter {
	public toView(value) {
		for (const property in value) {
			if (value[property] && value[property].amount) {
				if (value[property].amount > 0) {
					return 'YES';
				}
			}
		}
		return 'NO';
	}
}
